import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import GoogleIcon from '../../components/icon/GoogleIcon'
import { RbacStatusChip } from './RbacChips'
import {
  RBAC_DETAIL_ICON_COLOR,
  rbacSummaryMetaItemSx,
  rbacSummaryMetaTextSx,
  rbacSummaryTitleSx,
  rbacUserSummaryCardSx
} from './constants/rbacDetailCardConstants'
import {
  formatRbacUserDate,
  getRbacUserDisplayName,
  getRbacUserStatusMeta
} from '../pages/shared/rbacUserDetailHelpers'

function SummaryMetaItem({ icon, label, value }) {
  return (
    <Box sx={rbacSummaryMetaItemSx}>
      <GoogleIcon name={icon} size={14} color={RBAC_DETAIL_ICON_COLOR} />
      <Typography component="span" sx={{ ...rbacSummaryMetaTextSx, fontWeight: 700 }}>
        {label}
      </Typography>
      <Typography component="span" sx={{ ...rbacSummaryMetaTextSx, fontWeight: 400 }}>
        {value}
      </Typography>
    </Box>
  )
}

export default function RbacUserSummaryCard({ user }) {
  const statusMeta = getRbacUserStatusMeta(user)

  return (
    <Box sx={rbacUserSummaryCardSx}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <Typography fontWeight={700} fontSize={16} sx={rbacSummaryTitleSx}>
          {getRbacUserDisplayName(user)}
        </Typography>
        <RbacStatusChip label={statusMeta.label} />
      </Stack>

      <Stack direction="row" spacing={2.5} useFlexGap flexWrap="wrap" alignItems="center">
        <SummaryMetaItem icon="person" label="Código:" value={user?.code || '—'} />
        <SummaryMetaItem
          icon="event"
          label="Fecha de creación:"
          value={formatRbacUserDate(user?.created_at)}
        />
      </Stack>
    </Box>
  )
}
